import React, { useState, useEffect } from "react";
import { Layout, Col, Row, Button, PageHeader } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { URL } from "../00_Nav/url";
// component
import LayoutBreadCrumb from "../00_Nav/layout/layout_bread_crumb";
import BranchSearch from "./component/branch_search";
import BranchListing from "./component/branch_listing";
import Banner from "../../asset/img/banner-branch-2.jpg";
// redux
import {
  snapBranchs,
  unSnapBranchs,
  snapStaffBranchs,
  unSnapStaffBranchs,
} from "../../store/branch/branch.action";
import { branchsSelector } from "../../store/branch/branch.selector";
import { isOwnerSelector } from "../../store/role/role.selector";
import LayoutFooter from "../00_Nav/layout/layout_footer";

const { Content } = Layout;

const BranchManagementScreen = () => {
  // -------------------------- VAR --------------------------
  const breadCrumb = [
    { title: "Home", url: URL.home },
    { title: "Branchs", url: null },
  ];
  const title = "Branchs";
  const addHref = "/branchs/add";
  // -------------------------- STATE --------------------------
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const branchs = useSelector(branchsSelector);
  const isOwner = useSelector(isOwnerSelector);
  console.log("isOwner", isOwner);
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(
      snapBranchs(() => {
        setLoading(false);
      })
    );

    return () => {
      dispatch(unSnapBranchs());
    };
  }, [dispatch]);

  //snapStaffbranch
  useEffect(() => {
    if (!isOwner && isOwner !== null) {
      dispatch(snapStaffBranchs());
    }

    return () => dispatch(unSnapStaffBranchs());
  }, [isOwner, dispatch]);

  useEffect(() => {
    let data = branchs || [];
    if (search !== "") {
      data = data?.filter((item) => {
        const title = item?.name?.toLowerCase();
        const text = search?.toLowerCase();
        const found = title?.includes(text);
        return found;
      });
    }
    setData(data);
  }, [branchs, search]);

  // -------------------------- DATA FUNCTION --------------------------
  // -------------------------- RENDER --------------------------

  const renderBanner = () => {
    return (
      <div
        style={{
          width: "100%",
          height: 240,
          margin: "10px 0px 20px",
          backgroundImage: `url("${Banner}")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          borderRadius: 10,
          position: "relative",
        }}
      >
        <div
          style={{ position: "absolute", bottom: 5, left: 20, color: "white" }}
        >
          <div
            style={{
              fontSize: 56,

              fontWeight: "bold",
            }}
          >
            Branch Management
          </div>
          <p style={{ marginLeft: 5 }}>
            Your role: {isOwner ? "Owner" : "Staff"}
          </p>
        </div>
      </div>
    );
  };

  const renderTopBar = () => {
    return (
      <Row gutter={[16, 12]}>
        <Col lg={12} md={12} sm={12} xs={12}>
          <BranchSearch onChange={setSearch} />
        </Col>
        <Col lg={12} md={12} sm={12} xs={12}>
          {renderAddButton()}
        </Col>
      </Row>
    );
  };

  const renderAddButton = () => {
    return (
      <Row justify="end" align="middle" gutter={[16, 16]}>
        <Col>Total List: {data?.length || 0}</Col>
        <Col>
          <Button
            icon={<PlusOutlined />}
            color="primary"
            type="primary"
            href={addHref}
            disabled={!isOwner}
          >
            Add Branch
          </Button>
        </Col>
      </Row>
    );
  };

  const renderList = () => {
    return (
      <Row justify="end" align="middle" gutter={[16, 16]}>
        <Col lg={24} md={24} sm={24} xs={24}>
          <BranchListing data={data} loading={loading} owner={isOwner} />
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------

  return (
    <Layout className="site-layout full">
      <Content className="content page-content">
        <LayoutBreadCrumb data={breadCrumb} />
        {/* <PageHeader className="no-padding-header" title={title} subTitle="" /> */}
        {renderBanner()}
        {renderTopBar()}
        {renderList()}
      </Content>
      <LayoutFooter />
    </Layout>
  );
};

export default BranchManagementScreen;
